import React, {
  FC,
  memo,
  useCallback,
}                                  from 'react';
import { FormikConfig }            from 'formik';
import { IIntranetUserValues }     from '@typings/manageIntranetUsers';
import { IAuthUser }               from '@modules/auth/authReducer';
import {
  useFetchIntraUserDetails,
  useSubmitIntraUser,
  useRemoveIntraUser,
}                                  from '@modules/manageIntranetUsers/queries/intranetUsersQueries';
import { Loader }                  from '@components/Loader/Loader';
import { IntranetUserDetailsPage } from '@modules/manageIntranetUsers/pages/IntranetUserDetailsPage';

interface IProps {
  id?      : string;
  authUser : IAuthUser;
  onCancel : () => void;
}

const IntranetUserDetails: FC<IProps> = ({ id, authUser, onCancel }) => {
  // #region API INTEGRATION
  const {
    data: intraUser,
    isLoading,
  } = useFetchIntraUserDetails(
    id as string,
    { enabled: !!id },
  );

  const { mutateAsync: submitIntraUser } = useSubmitIntraUser();

  const { mutateAsync: deleteIntraUser, isLoading: isUserDeleting } = useRemoveIntraUser({
    onSuccess: () => {
      setTimeout(onCancel, 3500);
    },
  });
  // #endregion

  const onSubmit = useCallback<FormikConfig<IIntranetUserValues>['onSubmit']>(
    async (values) => {
      await submitIntraUser(values);
      setTimeout(onCancel, 3500);
    },
    [onCancel, submitIntraUser],
  );

  if (isLoading) {
    return <Loader />;
  }

  return (
    <IntranetUserDetailsPage
      onSubmit            = {onSubmit}
      onCancel            = {onCancel}
      onDelete            = {() => deleteIntraUser(id as string)}
      authUser            = {authUser}
      isUserDeleting      = {isUserDeleting}
      currentIntranetUser = {intraUser ?? null}
    />
  );
};

export const IntranetUserDetailsContainer = memo(IntranetUserDetails);
